import React, { useMemo } from "react";
import { Dropdown } from "primereact/dropdown";

const AddressDropdown = ({ options, placeholder, onChange, selectedValue, onAddNewAddress, width, disable = false }) => {
  // Create flattened options using compositeKey as value
  const flattenedOptions = useMemo(() => {
    // Debug: log raw options to check field names
    // console.log("AddressDropdown - raw options:", options);

    const addressOptions = (options || []).map((address) => {
      // Support both camelCase and PascalCase field names from different API sources
      const street = address.address || address.Address || address.address1 || address.Address1 || "";
      const city = address.city || address.City || "";
      const state = address.stateCode || address.StateCode || address.state || address.State || "";
      const zip = address.zipCode || address.ZipCode || address.zip || address.Zip || "";
      const country = address.countryCode || address.CountryCode || "";
      const contactId = address.contactId || address.ContactId || "";
      const addressId = address.addressId || address.AddressId || "";

      return {
        label: `${street}, ${city}, ${state} ${zip}, ${country}`.replace(/^,\s*|,\s*$/g, "").trim(),
        value: address.compositeKey || `${addressId}-${contactId}`,
        originalData: address,
      };
    });

    // Add the "Select a different one" option at the end
    addressOptions.push({
      label: "Select a different one",
      value: "ADD_NEW_ADDRESS",
      originalData: null,
      isAddNew: true,
    });

    return addressOptions;
  }, [options]);

  const customItemTemplate = (option) => {
    // Special template for "Select a different one" option
    if (option?.isAddNew) {
      return (
        <div
          style={{
            fontFamily: "Verizon-NHG-eDS",
            padding: "12px 0",
          }}
        >
          <div
            style={{
              fontSize: "14px",
              fontWeight: 400,
              lineHeight: "18px",
            }}
          >
            {option.label}
          </div>
        </div>
      );
    }

    return (
      <div
        style={{
          fontFamily: "Verizon-NHG-eDS",
          padding: "12px 0",
          borderBottom: "1px solid #F8F7F5",
        }}
      >
        <div
          style={{
            fontSize: "14px",
            fontWeight: 400,
            lineHeight: "18px",
          }}
        >
          {option.label}
        </div>
        <div
          style={{
            fontSize: "14px",
            lineHeight: "18px",
          }}
        >
          <span style={{ fontWeight: 700 }}>Contact: </span>
          <label>{option?.originalData?.contactName}</label>
        </div>
      </div>
    );
  };

  const handleChange = (value) => {
    if (value === "ADD_NEW_ADDRESS") {
      // Trigger the popup for adding new address
      if (onAddNewAddress) {
        onAddNewAddress();
      }
    } else {
      onChange(value);
    }
  };

  return (
    <div>
      <style>
        {`
          .custom-address-dropdown-panel .p-dropdown-items .p-dropdown-item {
            padding: 0 !important;
          }
        `}
      </style>
      <Dropdown
        disabled={disable}
        value={selectedValue}
        options={flattenedOptions}
        onChange={(e) => handleChange(e.value)}
        optionLabel="label"
        optionValue="value"
        itemTemplate={customItemTemplate}
        placeholder={placeholder}
        style={{
          width: width || "318px", // ✅ Use prop width or fallback to default
          fontFamily: "Verizon-NHG-eDS",
          height: "44px",
          background: "#fff",
        }}
        panelStyle={{
          borderRadius: "8px",
          width: "392px",
          fontFamily: "Verizon-NHG-eDS",
          padding: "0 12px",
          maxHeight: "162px", // Set maximum height for the panel
          overflowY: "auto", // Enable vertical scrolling
        }}
        panelClassName="custom-address-dropdown-panel"
      />
    </div>
  );
};

export default AddressDropdown;
